import CleaningStaffCalendar from '../../components/timeEntry/CleaningStaffCalendar';

const MyTimeSheet = () => {
  return <CleaningStaffCalendar />;
};

export default MyTimeSheet;
